<div class="row">
  <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
    <div class="d-flex sub-header">
      <div class="p-2 mr-auto title"><a><i class="back-icon" (click)="navigateToTable()"></i></a> {{pageMeta.pageTitle}}
      </div>
    </div>

  </div>
</div>

<div class="bg-white-round">
  <div class="row">
    <div class="col-12">
      <form [formGroup]="initForm" class="form">

        <div class="form-group col-12 col-md-6 margin-left ">
          <div class="margin-left">
            <sm-input [props]="pageMeta.properties.title"
              formControlName="{{ pageMeta.properties.title.field_Name }}"></sm-input>
          </div>
        </div>


        <fieldset class="Question-fieldset">
          <legend class="float-none w-auto Question"> Categories </legend>

          <div class="form-group col-12 col-md-12 justify-content-start m-0 p-0">
            <ng-container formArrayName="categories">
              <ng-container *ngFor="
                  let categoriesListArr of categoriesList().controls;
                  let i = index
                ">
                <div [formGroup]="categoriesListArr" class="form-row align-items-center">
                  <div class="col-12 col-md-6 margin-left">
                    <!-- <sm-input [props]="pageMeta.properties.categories.propfields.category" formControlName="{{
                       pageMeta.properties.categories.propfields.category.field_Name
                      }}" (InputAction)="performInputAction($event,i)"></sm-input> -->
                      <sm-input [props]="pageMeta.properties.categories.propfields.category" formControlName="{{
                        pageMeta.properties.categories.propfields.category.field_Name
                       }}" (change)="performInputAction($event,i)"></sm-input>
                  </div>
                  <div *ngIf="categoriesList().controls.length > 1" class="col-auto mt-2">
                    <img (click)="removeCategory(i)" src="assets/images/cross-outlined-red.svg" />
                  </div>
                </div>
                <div *ngIf="i === categoriesList().controls.length - 1" class="col-auto">
                  <button class="btn btn-primary mx-2" type="button" (click)="addCategories('')">
                    Add Categories
                  </button>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </fieldset>


        <fieldset class="Question-fieldset">


          <legend class="float-none w-auto Question"> Question </legend>


          <div class="form-group col-12 col-md-12 justify-content-start m-0 p-0">
            <ng-container formArrayName="questions">
              <ng-container *ngFor="
                  let questionList of getQuestionList().controls;
                  let i = index
                ">
                <div [formGroup]="questionList" class="form-row align-items-center mx-1 mb-2">
                  <div class="col-12 mb-2">
                    <!-- pageMeta.properties.categories.propfields.category -->
                    
                    <sm-simple-textarea [props]="pageMeta.properties.questions.fields.question_text" formControlName="{{
                       pageMeta.properties.questions.fields.question_text.field_Name
                      }}"></sm-simple-textarea>
                  </div>

                  <div class="col-11 col-md-5">

                    <!-- <sm-select [props]="field" [options]="field.options" formControlName="{{ field.field_Name }}"
                    *ngIf="field.fieldType === 'select'" (selected)="setValue(form, $event, i, field)" ></sm-select>
                     -->
                    <sm-select [props]="pageMeta.properties.questions.fields.selected_category_text"
                      [options]="pageMeta.properties.questions.fields.selected_category_text.options" formControlName="{{
                       pageMeta.properties.questions.fields.selected_category_text.field_Name
                      }}"></sm-select>
                  </div>
                  <div class="col-11 col-md-5">

                    <sm-select [props]="pageMeta.properties.questions.fields.question_type"
                      [options]="pageMeta.properties.questions.fields.question_type.options" formControlName="{{
                       pageMeta.properties.questions.fields.question_type.field_Name
                      }}" (selected)="onSelectedQuestion_type($event,i)"></sm-select>

                      
                  </div>
                  <div class="col-md-1 mt-2">
                    <div *ngIf="getQuestionList().controls.length > 1" class="col-auto">
                      <img (click)="removeQuestiolist(i)" src="assets/images/cross-outlined-red.svg" />
                    </div>
                  </div>
                  <ng-container *ngIf="getQuestionListOption(i).controls.length !==  0" formArrayName="options">
                    <ng-container *ngFor="
                  let optionList of getQuestionListOption(i).controls;
                  let ind = index
                  ">
                  <div [formGroup]="optionList" class="form-row mb-2 col-12">
                    <!-- Option Text Input -->
                    <div class="col-6 mb-2">
                      <sm-input [props]="pageMeta.properties.questions.fields.options.fields.option_text"
                        formControlName="option_text">
                      </sm-input>
                    </div>
                  
                    <div *ngIf="getQuestionListOption(i).controls.length > 1" class="col-1 text-start mt-4">
                      <img 
                        class="mt-3 mx-3" 
                        (click)="removeOptionList(i, ind)" 
                        src="assets/images/cross-outlined-red.svg" 
                      />
                    </div>
                
                    

                    <div *ngIf="ind === getQuestionListOption(i).controls.length - 1" class="col-1 text-start mt-4">
                      <button class="btn btn-primary mt-1" type="button" (click)="addOptions(i)">
                        Add
                      </button>
                    </div>
                  
                    
                  </div>
                  
                  
                    </ng-container>
                  </ng-container>
                </div>
                
                <div *ngIf="i === getQuestionList().controls.length - 1" class="mx-2">
                  <button class="btn btn-primary" type="button" (click)="addQuestions()">
                    Add Questions
                  </button>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </fieldset>

        <div class="text-center mt-4">
          <!-- <sm-btn [props]="pageMeta.properties.buttons.submit" (kClick)="onSubmit($event)"></sm-btn> -->
          <sm-ui-toolbar
          [btnProps]="pageMeta.properties.buttons"
          [form]="initForm"
          (add)="onSubmit($event)"
          (res)="resetForm()"
          [MetaModel]="pageMeta"
        ></sm-ui-toolbar>
        </div>


      </form>

    </div>
  </div>
</div>
<!-- [valid]="!initForm.valid" -->